<div *ngIf="media?.type !== 'nothing'"
     class="activity-edition-preview__media"
     [ngClass]="'activity-edition-preview__media--step-' + currentStepNumber"
     [class.activity-edition-preview__media--placeholder]="!isMediaTypeSelectorActive"
     [class.activity-edition-preview__media--active]="stepInFocus === 'ADD_MEDIA'"
     [@fadeAndSlideInAndOut]>

    <ng-container *ngIf="media as mediaData; else addMediaPlaceholder">
        <ng-container *ngIf="!!mediaData.value; else addMediaPlaceholder">
            <ng-container *ngIf="mediaData.type === 'flashcards'">
                <div [class.activity-edition-preview__flashcard-media-wrapper]="mediaData.value.length > 1">
                    <app-flashcard *ngFor="let flashcard of mediaData.value"
                                   [class.button-image]="flashcard.flashcard.image?.uri"
                                   [class.is-audio]="flashcard.flashcard.audio?.uri"
                                   [flashCard]="flashcard.flashcard"
                                   class="activity-edition-preview__flashcard-media">
                    </app-flashcard>
                </div>
            </ng-container>
            <img *ngIf="mediaData.type === 'image'"
                 class="activity-edition-preview__image-media"
                 [src]="mediaData.value.uri"
                 [@fadeAndSlideInAndOut]>
            <div *ngIf="mediaData.type === 'texte'"
                 class="activity-edition-preview__text-media-wrapper"
                 [@fadeAndSlideInAndOut]>
                <p class="activity-edition-preview__text-media" [innerHTML]="mediaData.value"></p>
            </div>
            <video *ngIf="mediaData.type === 'vidéo'"
                   class="activity-edition-preview__video-media"
                   [src]="mediaData.value.uri"
                   controls
                   [@fadeAndSlideInAndOut]>
            </video>
            <div *ngIf="mediaData.type === 'audio'"
                 class="activity-edition-preview__audio-media-wrapper"
                 [@fadeAndSlideInAndOut]>
                <mat-icon class="activity-edition-preview__audio-icon"
                          svgIcon="activity-edition-preview__audio">
                </mat-icon>
                <audio class="activity-edition-preview__audio-media"
                       [src]="mediaData.value.uri"
                       controls>
                </audio>
            </div>
        </ng-container>
    </ng-container>
    <ng-template #addMediaPlaceholder>
        <div class="activity-edition-preview__media-placeholder"
             [@fadeAndSlideInAndOut]>
            <mat-icon class="activity-edition-preview__media-placeholder-icon"
                      svgIcon="image">
            </mat-icon>
            <p class="activity-edition-preview__media-placeholder-text"
               [innerHTML]="'activity_edition.add_media' | translate">
            </p>
        </div>
    </ng-template>
</div>